import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import ActionsForm from '@/shared/mixins/actionsForm'
// import OcurrenceLogRepository from '@/shared/http/repositories/realestate/occurencelog'

export default {
  name: 'logOcurrence',
  mixins: [ActionsForm, ExpenseMixin],
  props: {
    // dataDetails: {
    //   type: Object,
    //   default: {}
    // },
    // logOcurrence: {
    //   type: Boolean,
    //   default: false
    // },
    // refreshLog: {
    //   type: Boolean,
    //   default: false
    // }
    buttonsAccredited: {
      type: Boolean,
      default: false
    },
    btnSing: {
      type: Number,
      default: 0
    },
    btnNewPdf: {
      type: Number,
      default: 0
    },
    dataDetails: {
      type: Object,
      default: {}
    }

  },
  watch: {
    // serachiput (newvalue) {
    //   this.logallfilter = this.logAll.filter((Element) => Element.titulo.toUpperCase().includes(newvalue.toUpperCase()))
    // },
    // refreshLog (newvalue) {
    //   if (this.logRefresh !== newvalue) {
    //     this.getLogById(this.dataDetails)
    //   }
    //   this.logRefresh = false
    // }
  },
  components: {HeadDetailsGama},
  data () {
    return {
      logAll: [],
      serachiput: '',
      logallfilter: [],
      checkUltimoLog: null,
      logRefresh: false
    }
  },
  mounted () {
    // this.getLogById(this.dataDetails)
  },
  methods: {
    // getLogById (e) {
    //   let id = e.id
    //   console.log(e)
    //   OcurrenceLogRepository.GetLogById(id)
    //     .then((res) => {
    //       this.logAll = res.data

    //       this.checkUltimoLog = this.logAll.filter(({ultimoLog}) => {
    //         return ultimoLog === true
    //       })
    //       console.log(res)
    //     })
    //     .catch(() => {})
    // }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/FormDetailsAdvance/component/logAdvance.js